import { MutationResult } from "@/api/utils/types"
import { useMutation } from "@/api/utils/useQuery"
import { ApiGatewayMutations } from "@/api/apiGateway/mutations"
import { IConsentRawData } from "@/models/consent/consent.parser"
import { IUpdateMeterConsent } from "./ConsentMutator.types"

export interface IConsentMutator {
  updateSmartRead(onSuccess: Function): MutationResult<IUpdateMeterConsent[]>
}

class ConsentMutatorClass implements IConsentMutator {
  updateSmartRead(onSuccess) {
    return useMutation({
      ...ApiGatewayMutations.consent.update(),
      serializerFn: (data: IUpdateMeterConsent[]): IConsentRawData => {
        return {
          "frequency-consent": data,
        }
      },
      onSuccessFn: onSuccess,
    })
  }
}

export const ConsentMutator = new ConsentMutatorClass()
